"use strict";
import {
  render,
  createContext
} from "@easrng/elements/tiny";
import inspect from "object-inspect";
import { logs } from "./hook.ts";
import { eventBus } from "../eventBus.ts";
if (ENAFORE_IS_BROWSER) {
  let transpose = function(matrix) {
    return matrix[0].map((col, i) => matrix.map((row) => row[i]));
  };
  var transpose2 = transpose;
  const DefaultFormat = ({ args, html }) => {
    const first = args[0];
    let a = 0;
    let out = [];
    let styled = [];
    let css = "";
    function flush() {
      if (out.length) {
        styled.push(css ? html`<span style=${css}>${out}</>` : html`${out}`);
        out = [];
      }
    }
    if (typeof first == "string" && args.length > 1) {
      a++;
      let appendedChars = 0;
      for (let i = 0; i < first.length - 1; i++) {
        if (first[i] == "%") {
          const char = first[++i];
          if (a < args.length) {
            let formattedArg = "";
            if (char == "s") {
              formattedArg = String(args[a++]);
            } else if (Array.prototype.includes.call(["d", "i"], char)) {
              const value = args[a++];
              if (typeof value == "bigint") {
                formattedArg = `${value}n`;
              } else if (typeof value == "number") {
                formattedArg = `${Number.parseInt(String(value))}`;
              } else {
                formattedArg = "NaN";
              }
            } else if (char == "f") {
              const value = args[a++];
              if (typeof value == "number") {
                formattedArg = `${value}`;
              } else {
                formattedArg = "NaN";
              }
            } else if (Array.prototype.includes.call(["O", "o"], char)) {
              formattedArg = inspect(args[a++]);
            } else if (char == "c") {
              const value = String(args[a++]);
              flush();
              css = value;
            }
            if (formattedArg != null) {
              out.push(
                String.prototype.slice.call(first, appendedChars, i - 1) + formattedArg
              );
              appendedChars = i + 1;
            }
          }
          if (char == "%") {
            out.push(
              String.prototype.slice.call(first, appendedChars, i - 1) + "%"
            );
            appendedChars = i + 1;
          }
        }
      }
      out.push(String.prototype.slice.call(first, appendedChars));
    }
    flush();
    css = "";
    for (; a < args.length; a++) {
      if (a > 0) {
        out.push(" ");
      }
      if (typeof args[a] == "string") {
        out.push(String(args[a]));
      } else {
        out.push(inspect(args[a]));
      }
    }
    flush();
    return html`<span class=message>${styled}</>`;
  };
  const Table = ({
    args: [data, properties],
    html
  }) => {
    if (properties !== void 0 && !Array.isArray(properties) || data === null || typeof data !== "object") {
      return html`<${DefaultFormat} args=${[data, properties]}/>`;
    }
    let resultData;
    const isSetObject = data instanceof Set;
    const isMapObject = data instanceof Map;
    const valuesKey = "Values";
    const indexKey = isSetObject || isMapObject ? "(iter idx)" : "(idx)";
    if (isSetObject) {
      resultData = [...data];
    } else if (isMapObject) {
      let idx = 0;
      resultData = {};
      Map.prototype.forEach.call(data, (v, k) => {
        resultData[idx] = { Key: k, Values: v };
        idx++;
      });
    } else {
      resultData = data;
    }
    const keys = Object.keys(resultData);
    const numRows = keys.length;
    const objectValues = properties ? Object.fromEntries(
      properties.map((name) => [
        String(name),
        Array.prototype.fill.call(new Array(numRows), "")
      ])
    ) : {};
    const indexKeys = [];
    const values = [];
    let hasPrimitives = false;
    keys.forEach((k, idx) => {
      const value = resultData[k];
      const primitive = value === null || typeof value !== "function" && typeof value !== "object";
      if (properties === void 0 && primitive) {
        hasPrimitives = true;
        values.push(html`<${DefaultFormat} args=${[value]}/>`);
      } else {
        const valueObj = value || {};
        const keys2 = properties || Object.keys(valueObj);
        for (let i = 0; i < keys2.length; ++i) {
          const k2 = keys2[i];
          if (!primitive && Reflect.has(valueObj, k2)) {
            if (!Reflect.has(objectValues, k2)) {
              objectValues[k2] = new Array(numRows).fill("");
            }
            objectValues[k2][idx] = html`<${DefaultFormat} args=${[valueObj[k2]]}/>`;
          }
        }
        values.push("");
      }
      indexKeys.push(k);
    });
    const headerKeys = Object.keys(objectValues);
    const bodyValues = Object.values(objectValues);
    const headerProps = properties || [
      ...headerKeys,
      !isMapObject && hasPrimitives && valuesKey
    ];
    const header = Array.prototype.filter.call(
      [indexKey, ...headerProps],
      Boolean
    );
    const body = [indexKeys, ...bodyValues, values];
    return html`<div class=message><div class=table-wrap><table><thead><tr>${header.map((e) => html`<th>${e}</>`)}</></><tbody>${transpose(body).map(
      (e) => html`<tr>${e.slice(0, header.length).map(
        (e2, i) => i ? html`<td>${e2}</>` : html`<th>${e2}</>`
      )}</>`
    )}</></></></>`;
  };
  const icons = {
    error: "\u26D4",
    warn: "\u26A0\uFE0F",
    info: "\u2139\uFE0F",
    debug: "\u{1F41E}",
    unknown: "\u2753"
  };
  const known = /* @__PURE__ */ new Set([
    "log",
    "clear",
    "table",
    "assert",
    "count",
    "countReset",
    "dir",
    "dirxml",
    "exception",
    "time",
    "timeEnd",
    "timeLog",
    "timeStamp",
    "trace",
    "profile",
    "profileEnd",
    ...Object.keys(icons)
  ]);
  const TimesContext = createContext();
  const CountsContext = createContext();
  const LogLine = ({ log, html, context }) => {
    const times = context(TimesContext);
    const counts = context(CountsContext);
    let stackEle = "";
    let unknownType;
    if (!known.has(log.type)) {
      unknownType = log.type;
      log.type = "unknown";
    }
    if (log.type === "timeStamp" || log.type === "profile" || log.type === "profileEnd") {
      return "";
    }
    if (log.type === "assert") {
      if (log.args[0]) return "";
      log.type = "error";
      log.args[0] = "Assertion failed:";
      log.args.push("\n" + log.stack);
    }
    const label = log.args[0] === void 0 ? "default" : `${log.args[0]}`;
    {
      const reset = log.type === "countReset";
      if (log.type === "count" || log.type === "countReset") {
        const newCount = reset ? 0 : (counts.get(label) || 0) + 1;
        counts.set(label, newCount);
        if (reset) return "";
        log.args = [label + ":", newCount];
        log.type = "count";
      }
    }
    if (log.type === "time" || log.type === "countReset") {
      if (times.has(label)) {
        log.type = "warn";
        log.args = [`Timer '${label}' already exists.`];
      } else {
        times.set(label, log.time);
        return "";
      }
    }
    if (log.type === "timeLog" || log.type === "timeEnd") {
      if (times.has(label)) {
        log.args = [`${label}: ${log.time - times.get(label)}ms`];
        if (log.type === "timeEnd") {
          times.delete(label);
        }
      } else {
        log.type = "warn";
        log.args = [`Timer '${label}' doesn't exist.`];
      }
    }
    if (log.type === "dir" || log.type === "dirxml") {
      log.type = "log";
    }
    if (log.type === "exception") {
      log.type = "error";
    }
    if (log.type === "trace") {
      log.args.unshift("Trace" + (log.args.length ? ":" : ""));
      log.args.push("\n" + log.stack);
    }
    const icon = icons[log.type] ? html`<span class=icon title=${log.type} aria-label=${log.type}>${icons[log.type]}</>` : "";
    let content;
    if (log.type === "clear") {
      content = html`<i class=message>Ignored console.clear()</>`;
    } else if (log.type === "table") {
      content = html`<${Table} args=${log.args}/>`;
    } else if (log.type === "unknown") {
      content = html`<b>${unknownType}</>: <${DefaultFormat} args=${log.args}/>`;
    } else {
      content = html`<${DefaultFormat} args=${log.args}/>`;
    }
    return html`<li class=${"log log-" + log.type}>${icon} ${content} ${stackEle}</>`;
  };
  class ConsoleLogs extends HTMLElement {
    constructor() {
      super();
      this._onLog = this._onLog.bind(this);
    }
    connectedCallback() {
      this.textContent = "";
      const ul = document.createElement("ul");
      this.append(ul);
      this._times = /* @__PURE__ */ new Map();
      this._counts = /* @__PURE__ */ new Map();
      eventBus.on("console", this._onLog);
      this.firstElementChild.append(
        render(
          ({ html }) => html`<${TimesContext} value=${this._times}><${CountsContext} value=${this._counts}>${logs.map((log) => html`<${LogLine} log=${log}/>`)}</></>`
        )
      );
    }
    disconnectedCallback() {
      this.textContent = "";
      eventBus.off("console", this._onLog);
    }
    _onLog(log) {
      this.firstElementChild.append(
        render(
          ({ html }) => html`<${TimesContext} value=${this._times}><${CountsContext} value=${this._counts}><${LogLine} log=${log}/></></>`
        )
      );
    }
  }
  customElements.define("easrng-console-logs", ConsoleLogs);
}
